"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var clinicianNotificationListForAdminView = function clinicianNotificationListForAdminView(dataSource, definitions, onChange, selectedFilters, getCurrentColumnSortOrder) {
  var columns = [{
    title: 'Notification Type',
    dataIndex: 'type',
    key: 'type',
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    sortOrder: getCurrentColumnSortOrder('type'),
    filters: [{
      text: "Message from ".concat((0, _utils.getRoleNameLower)(_utils.UserRoles.Doctor)),
      value: 'message-from-physician'
    }, {
      text: 'Booking confirmation',
      value: 'clinician-booking-confirmation'
    }, {
      text: 'Booking reminder 24hr',
      value: 'clinician-booking-24hr-reminder'
    }, {
      text: 'Booking reminder 10min',
      value: 'clinician-booking-10min-reminder'
    }, {
      text: 'Booking cancellation',
      value: 'clinician-booking-cancellation'
    }, {
      text: 'Booking rescheduled',
      value: 'clinician-booking-rescheduled'
    }, {
      text: 'Message from Patient',
      value: 'clinician-message-from-patient'
    }, {
      text: 'Clinician matched to Patient',
      value: 'clinician-matched-to-patient'
    }],
    filteredValue: selectedFilters.type ? [selectedFilters.type] : null,
    filterMultiple: false,
    onFilter: function onFilter(value, record) {
      return value === record.type;
    },
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.type);
    },
    width: '170px',
    align: 'left',
    vertical: 'top'
  }, {
    title: 'Notification Channel',
    dataIndex: 'channel',
    key: 'channel',
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    sortOrder: getCurrentColumnSortOrder('channel'),
    filters: [{
      text: 'Application',
      value: 'application'
    }, {
      text: 'SMS',
      value: 'SMS'
    }, {
      text: 'Email',
      value: 'email'
    }, {
      text: 'Chat',
      value: 'chat'
    }],
    filteredValue: selectedFilters.channel ? [selectedFilters.channel] : null,
    filterMultiple: false,
    onFilter: function onFilter(value, record) {
      return value === record.channel;
    },
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.channel);
    },
    width: '170px',
    align: 'center'
  }, {
    title: 'Notification Status',
    dataIndex: 'status',
    key: 'status',
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    sortOrder: getCurrentColumnSortOrder('status'),
    filters: [{
      text: 'Pending',
      value: 'pending'
    }, {
      text: 'Pushed',
      value: 'pushed'
    }, {
      text: 'InternalError',
      value: 'internal-error'
    }, {
      text: 'Rejected',
      value: 'rejected'
    }, {
      text: 'Dismissed',
      value: 'dismissed'
    }, {
      text: 'Outdated',
      value: 'outdated'
    }, {
      text: 'Attempted',
      value: 'attempted'
    }, {
      text: 'Sent',
      value: 'sent'
    }, {
      text: 'Delivered',
      value: 'delivered'
    }, {
      text: 'Failed',
      value: 'failed'
    }, {
      text: 'Bounced',
      value: 'bounced'
    }, {
      text: 'Undelivered',
      value: 'undelivered'
    }, {
      text: 'Accepted',
      value: 'accepted'
    }, {
      text: 'Queued',
      value: 'queued'
    }, {
      text: 'Sending',
      value: 'sending'
    }, {
      text: 'Receiving',
      value: 'receiving'
    }, {
      text: 'Received',
      value: 'received'
    }],
    filteredValue: selectedFilters.status ? [selectedFilters.status] : null,
    filterMultiple: false,
    onFilter: function onFilter(value, record) {
      return value === record.status;
    },
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.status);
    },
    width: '170px',
    align: 'center'
  }, {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.formatDate)(record.createdAt, {
        withTime: true
      }));
    },
    width: '160px'
  }, {
    title: 'Updated At',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.formatDate)(record.updatedAt, {
        withTime: true
      }));
    },
    width: '160px'
  }, {
    title: 'Details',
    dataIndex: 'details',
    key: 'details',
    sorter: false,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record ? JSON.stringify(record).substr(0, 254) : '');
    },
    width: '200px',
    align: 'center'
  }, {
    title: 'Error Details',
    dataIndex: 'errorDetails',
    key: 'errorDetails',
    sorter: false,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.errorDetails ? JSON.stringify(record.errorDetails).substr(0, 254) : '');
    },
    width: '200px',
    align: 'center'
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id',
    onChange: onChange
  };
};
var _default = clinicianNotificationListForAdminView;
exports.default = _default;